import { styled } from "../../../../styled-system/jsx";

const ExpanderContainer = styled("div", {
  base: {
    borderRadius: "standard",
    padding: "medium",
    fontSize: "medium",
    backgroundColor: "white",
  },
});

export default ExpanderContainer;
